module.exports = "pegasus/assets/themelp1/app/105.png";